var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 7.44501C0.75 4.08003 3.4264 1.375 6.7 1.375C9.9736 1.375 12.65 4.08003 12.65 7.44501C12.65 9.17953 12.1511 11.0818 11.2547 12.7323C10.3568 14.3856 9.09257 15.7288 7.60763 16.4229C7.03113 16.6924 6.36887 16.6924 5.79237 16.4229C4.30743 15.7288 3.04321 14.3856 2.14533 12.7323C1.2489 11.0818 0.75 9.17953 0.75 7.44501Z",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7,
    cy: 7.325,
    r: 1.7625,
    stroke: "#808080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.32014295a7010780fc120e4ba5fdf9eb.svg";
export { ForwardRef as ReactComponent };